export const localStorageKeys = {
  accessToken: 'access_token',
  currentUser: 'currentUser'
}